import { statusDisplayNameForTrackings } from '@rsos/constants/alertStatuses';
import { gspx } from '@rsos/gainsight';

export const trackRemoveFromQueue = (
  alertStatus,
  selectedAlertID,
  irpVersion,
) => {
  const displayStatus = statusDisplayNameForTrackings[alertStatus];

  gspx.trackCustomEvent('Alert', {
    irpVersion,
    name: `Click remove from queue button for ${displayStatus} alert in RSP`,
    Category: 'Alert',
    'Launched date': new Date(),
    AlertID: selectedAlertID,
  });
};
